function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var THREE = require('three');
var AdminNetworkUI = /*#__PURE__*/function () {
  function AdminNetworkUI(app, mod) {
    _classCallCheck(this, AdminNetworkUI);
    this.app = app;
    this.mod = mod;
    this.generation = 0;
  }
  return _createClass(AdminNetworkUI, [{
    key: "render",
    value: function render() {
      var _this = this;
      this.destroy();
      this.root = document.querySelector('.admin-network');
      if (!this.root) return;
      this.root.querySelector('button').onclick = function () {
        return _this.loadPeers();
      };
      this.draw([]);
      this.onResize = function () {
        return _this.fitToViewport();
      };
      window.addEventListener('resize', this.onResize);
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.root);
      }
      this.loadPeers();
    }
  }, {
    key: "loadPeers",
    value: function () {
      var _loadPeers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var generation, root, status, button, finish, tx, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              generation = ++this.generation;
              root = this.root;
              if (root) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              status = root.querySelector('[role="status"]');
              button = root.querySelector('button');
              finish = function finish(message) {
                if (generation !== _this2.generation) return;
                clearTimeout(_this2.timeout);
                status.textContent = message;
                button.disabled = false;
              };
              button.disabled = true;
              status.textContent = 'Loading connected nodes…';
              clearTimeout(this.timeout);
              this.timeout = setTimeout(function () {
                finish('Could not refresh connections. Please retry.');
                _this2.generation++;
              }, 15000);
              _context.p = 2;
              if (!(!this.mod.server_info || !this.mod.server_publickey)) {
                _context.n = 3;
                break;
              }
              finish('Waiting for administrator authentication.');
              return _context.a(2);
            case 3:
              _context.n = 4;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.mod.server_publickey);
            case 4:
              tx = _context.v;
              tx.msg = {
                module: 'Admin',
                request: 'list-peers'
              };
              _context.n = 5;
              return tx.sign();
            case 5:
              if (!(generation !== this.generation)) {
                _context.n = 6;
                break;
              }
              return _context.a(2);
            case 6:
              _context.n = 7;
              return this.app.network.sendTransactionWithCallback(tx, function (response) {
                if (generation !== _this2.generation) return;
                var res = typeof (response === null || response === void 0 ? void 0 : response.returnMessage) === 'function' ? response.returnMessage() : response;
                if (res !== null && res !== void 0 && res.err || !Array.isArray(res === null || res === void 0 ? void 0 : res.result)) {
                  finish((res === null || res === void 0 ? void 0 : res.err) || 'Could not load connections. Please retry.');
                  return;
                }
                var peers = res.result.filter(function (peer) {
                  return peer.status === 'connected';
                });
                _this2.draw(peers);
                finish(peers.length ? "".concat(peers.length, " connected nodes") : 'No connected nodes.');
              }, this.mod.server_publickey);
            case 7:
              _context.n = 9;
              break;
            case 8:
              _context.p = 8;
              _t = _context.v;
              finish('Could not load connections. Please retry.');
            case 9:
              return _context.a(2);
          }
        }, _callee, this, [[2, 8]]);
      }));
      function loadPeers() {
        return _loadPeers.apply(this, arguments);
      }
      return loadPeers;
    }()
  }, {
    key: "address",
    value: function address(peer) {
      var endpoint = peer.endpoint || peer;
      var host = endpoint.host || peer.host;
      if (!host) return peer.ip ? "IP: ".concat(peer.ip) : 'IP / URL unavailable';
      var hostname = host.includes(':') && !host.startsWith('[') ? "[".concat(host, "]") : host;
      var port = endpoint.port || peer.port;
      return "".concat(endpoint.protocol || peer.protocol || 'http', "://").concat(hostname).concat(port ? ":".concat(port) : '');
    }
  }, {
    key: "draw",
    value: function draw(peers) {
      var _this$mod$server_info,
        _this3 = this;
      this.disposeScene();
      var stage = this.root.querySelector('.admin-network-stage');
      stage.replaceChildren();
      // Logical node positions are fitted by the camera; labels stay in screen pixels.
      var radius = Math.max(250, peers.length * 38);
      var twoNodes = peers.length === 1;
      // Leave room to the right of the outermost node for its label.
      var width = twoNodes ? 440 : radius * 2 + 440;
      var height = twoNodes ? radius + 240 : radius * 2 + 240;
      var origin = new THREE.Vector3(0, twoNodes ? radius / 2 : 0, 0);
      stage.style.width = "".concat(width, "px");
      stage.style.height = "".concat(height, "px");
      var scene = this.scene = new THREE.Scene();
      var camera = this.camera = new THREE.OrthographicCamera(-width / 2, width / 2, height / 2, -height / 2, 1, 1000);
      camera.position.z = 600;
      scene.add(new THREE.AmbientLight(0xffffff, 2));
      var light = new THREE.DirectionalLight(0xffffff, 3);
      light.position.set(-100, 200, 400);
      scene.add(light);
      var nodes = [_objectSpread(_objectSpread({}, (_this$mod$server_info = this.mod.server_info) === null || _this$mod$server_info === void 0 || (_this$mod$server_info = _this$mod$server_info.options) === null || _this$mod$server_info === void 0 ? void 0 : _this$mod$server_info.server), {}, {
        // Use the same identity as the overview; server settings may contain an empty key.
        publicKey: this.mod.server_publickey,
        kind: 'This node',
        x: origin.x,
        y: origin.y,
        color: 0xe64760
      })].concat(_toConsumableArray(peers.map(function (peer, index) {
        var angle = index / peers.length * Math.PI * 2 + Math.PI / 2;
        return _objectSpread(_objectSpread({}, peer), {}, {
          kind: peer.synctype === 'full' ? 'Full node' : peer.synctype === 'lite' ? 'Browser' : 'Unknown type',
          x: twoNodes ? 0 : Math.cos(angle) * radius,
          y: twoNodes ? -radius / 2 : Math.sin(angle) * radius,
          color: peer.synctype === 'full' ? 0x357bd8 : 0x159b87
        });
      })));
      this.nodeLabels = [];
      nodes.forEach(function (node, index) {
        var position = new THREE.Vector3(node.x, node.y, 0);
        var sphere = new THREE.Mesh(new THREE.SphereGeometry(index ? 10 : 15, 24, 16), new THREE.MeshStandardMaterial({
          color: node.color,
          roughness: 0.35
        }));
        sphere.position.copy(position);
        scene.add(sphere);
        if (index) {
          var displacement = position.clone().sub(origin);
          var distance = displacement.length();
          var direction = displacement.normalize();
          var perpendicular = new THREE.Vector3(-direction.y, direction.x, 0);
          if (node.synctype === 'full') {
            // Parallel arrows, one in each direction, identify full-node links.
            for (var _i = 0, _arr = [-1, 1]; _i < _arr.length; _i++) {
              var sign = _arr[_i];
              var offset = perpendicular.clone().multiplyScalar(sign * 4);
              var start = sign === 1 ? origin.clone().addScaledVector(direction, 20) : position.clone().addScaledVector(direction, -20);
              scene.add(new THREE.ArrowHelper(direction.clone().multiplyScalar(sign), start.add(offset), distance - 40, node.color, 12, 7));
            }
          } else {
            scene.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints([origin, position]), new THREE.LineBasicMaterial({
              color: node.color
            })));
          }
        }
        var label = document.createElement('div');
        label.className = 'admin-network-label';
        _this3.nodeLabels.push({
          label: label,
          position: position
        });
        var title = document.createElement('strong');
        title.textContent = node.kind;
        var key = document.createElement('span');
        key.className = 'admin-network-key';
        key.textContent = node.publicKey || 'Public key unavailable';
        key.title = key.textContent;
        var address = document.createElement('span');
        address.textContent = _this3.address(node);
        label.append(title, key, address);
        stage.append(label);
      });
      try {
        var renderer = this.renderer = new THREE.WebGLRenderer({
          alpha: true,
          antialias: true
        });
        renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
        renderer.domElement.setAttribute('aria-hidden', 'true');
        stage.prepend(renderer.domElement);
        this.root.querySelector('.admin-network-fallback').hidden = true;
      } catch (err) {
        this.disposeScene();
        this.root.querySelector('.admin-network-fallback').hidden = false;
      }
      this.fitToViewport();
    }
  }, {
    key: "fitToViewport",
    value: function fitToViewport() {
      var _this$root$querySelec;
      if (!this.root) return;
      var viewport = this.root.querySelector('.admin-network-viewport');
      var stage = this.root.querySelector('.admin-network-stage');
      var size = this.root.querySelector('.admin-network-size');
      // Use the document position so scrolling does not change the diagram's size.
      var top = this.root.getBoundingClientRect().top + window.scrollY;
      var height = Math.max(600, window.innerHeight - top - 24);
      var width = Math.max(320, viewport.clientWidth || this.root.clientWidth || 600);
      this.root.style.setProperty('--admin-network-height', "".concat(height, "px"));
      stage.style.width = size.style.width = "".concat(width, "px");
      stage.style.height = size.style.height = "".concat(height, "px");
      var xs = this.nodeLabels.map(function (_ref) {
        var position = _ref.position;
        return position.x;
      });
      var ys = this.nodeLabels.map(function (_ref2) {
        var position = _ref2.position;
        return position.y;
      });
      var minX = Math.min.apply(Math, _toConsumableArray(xs)),
        maxX = Math.max.apply(Math, _toConsumableArray(xs));
      var minY = Math.min.apply(Math, _toConsumableArray(ys)),
        maxY = Math.max.apply(Math, _toConsumableArray(ys));
      // Reserve fixed pixel space for the controls and lower-right labels.
      var left = 30,
        right = width - 210;
      var topInset = Math.max(120, (((_this$root$querySelec = this.root.querySelector('.admin-network-controls')) === null || _this$root$querySelec === void 0 ? void 0 : _this$root$querySelec.offsetHeight) || 0) + 30);
      var bottom = height - 120;
      var scale = Math.min((right - left) / Math.max(1, maxX - minX), (bottom - topInset) / Math.max(1, maxY - minY), 1.5);
      var camera = this.camera;
      camera.left = -width / (2 * scale);
      camera.right = width / (2 * scale);
      camera.top = height / (2 * scale);
      camera.bottom = -height / (2 * scale);
      camera.position.x = (minX + maxX) / 2 - ((left + right) / 2 - width / 2) / scale;
      camera.position.y = (minY + maxY) / 2 + ((topInset + bottom) / 2 - height / 2) / scale;
      camera.updateProjectionMatrix();
      camera.updateMatrixWorld();
      var _iterator = _createForOfIteratorHelper(this.nodeLabels),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _step.value,
            label = _step$value.label,
            position = _step$value.position;
          var projected = position.clone().project(camera);
          label.style.left = "".concat((projected.x + 1) * width / 2 + 20, "px");
          label.style.top = "".concat((1 - projected.y) * height / 2 + 20, "px");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (this.renderer) {
        try {
          this.renderer.setSize(width, height, false);
          this.renderer.render(this.scene, camera);
        } catch (err) {
          this.disposeScene();
          this.root.querySelector('.admin-network-fallback').hidden = false;
        }
      }
    }
  }, {
    key: "disposeScene",
    value: function disposeScene() {
      var _this$scene, _this$renderer;
      var geometries = new Set();
      var materials = new Set();
      (_this$scene = this.scene) === null || _this$scene === void 0 || _this$scene.traverse(function (object) {
        if (object.geometry) geometries.add(object.geometry);
        if (object.material) materials.add(object.material);
      });
      geometries.forEach(function (geometry) {
        return geometry.dispose();
      });
      materials.forEach(function (material) {
        return material.dispose();
      });
      (_this$renderer = this.renderer) === null || _this$renderer === void 0 || _this$renderer.dispose();
      this.renderer = null;
      this.scene = null;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$resizeObserver;
      this.generation++;
      clearTimeout(this.timeout);
      window.removeEventListener('resize', this.onResize);
      (_this$resizeObserver = this.resizeObserver) === null || _this$resizeObserver === void 0 || _this$resizeObserver.disconnect();
      this.resizeObserver = null;
      this.disposeScene();
      this.nodeLabels = [];
      this.camera = null;
      this.root = null;
    }
  }]);
}();
module.exports = AdminNetworkUI;